/**
 * The angularjs states related to the module AddAccountModule
 */
whatsappCloudApiStates.$inject = ['$stateProvider'];
export function whatsappCloudApiStates($stateProvider) {

  $stateProvider
    .state('auth.alcmeon.fuse.parameters.whatsapp-cloud-api', {
      abstract: true,
      url: '/whatsapp-cloud-api'
    })
    .state('auth.alcmeon.fuse.parameters.whatsapp-cloud-api.pre-qualify', {
      url: '/pre-qualify',
      views: {
        'container@auth': {
          template: '<angular-whatsapp-cloud-api-pre-qualify></angular-whatsapp-cloud-api-pre-qualify>',
        }
      }
    })
    .state('auth.alcmeon.fuse.parameters.whatsapp-cloud-api.migrate', {
      url: '/:siteId/migrate?origin',
      views: {
        'container@auth': {
          template: '<angular-whatsapp-cloud-api-pre-qualify></angular-whatsapp-cloud-api-pre-qualify>',
        }
      }
    })
    ;
}
